import React from 'react';
import {BookOpen, Clock, ExternalLink, GraduationCap} from 'lucide-react';
import toFaNumber from "@/lib/utils/number";
import {weekdayString} from "@/lib/helper/weekday";
import {sprintf} from "@/lib/utils/sprintf";
import {URLS} from "@/lib/urls";
import {Link} from "react-router-dom";
import {Tag} from 'antd'


export const TeacherLessonCard = ({lesson}) => {

    return (<div
        className=" rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 border dark:border-gray-600 border-gray-100  group hover:-translate-y-1">
        <div className="p-6">
            {/* Header */}
            <h3 className="text-xl font-bold   mb-2 group-hover:text-blue-600 transition-colors duration-200">
                <Tag color={'green'}>کد: {toFaNumber(lesson?.code)}</Tag>
                {lesson?.topic?.title}
            </h3>

            <div className="my-2">
                <Tag color={'blue'}><span className={'font-bold'}>{lesson?.takenunits_count}</span> دانش آموز </Tag>
            </div>


            {/* Schedule Info */}
            <div className="space-y-3 mb-4">


                {(lesson?.times_detail && lesson?.times_detail.length > 0) &&
                    <div className="flex items-center  ">
                        <Clock className="w-4 h-4 ml-2 text-green-500"/>
                        <span className="text-sm">{lesson?.times_detail?.map((t, index) => (
                            <>
                                    <span className={'flex gap-1'}>
                                        <span className={'font-bold'}>{weekdayString(t.weekday)}</span>
                                        <span>{t.classroom.title}</span>
                                        <span>{toFaNumber(t.start)} - {toFaNumber(t.end)}</span>
                                    </span>

                            </>
                        ))} </span>
                    </div>}

                <div className="flex items-center  ">
                    <GraduationCap className="w-4 h-4 ml-2 text-orange-500"/>
                    <span className="text-sm">{lesson?.semester?.title}</span>
                </div>
            </div>

            {/* Description */}
            {lesson?.title && (<p className="  text-sm mb-4 leading-relaxed">
                {lesson?.title}
            </p>)}

            {/* Action Buttons */}
            <div className="flex gap-3 pt-4 border-t border-gray-100">
                <Link
                    to={sprintf(URLS.teacher.lessons.detail, {id: lesson?.id})}
                    className="flex-1 bg-blue-50 hover:bg-blue-100 text-blue-700 py-3 px-4 rounded-xl transition-all duration-200 flex items-center justify-center gap-2 text-sm font-medium hover:scale-105"
                >
                    <BookOpen className="w-4 h-4"/>
                    مشاهده جزئیات
                    <ExternalLink className="w-3 h-3"/>
                </Link>

            </div>
        </div>
    </div>);
};